var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"attachment-button",class:{
    'attachment-button--clickable': _vm.canDownload,
    'attachment-button--deactivated': !_vm.canDownload
  },attrs:{"close":_vm.close,"disabled":!_vm.canDownload},on:{"input":function($event){return _vm.$emit('input')},"click":_vm.downloadAttachment}},[_c('v-avatar',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":22,"width":2}}):_c('v-icon',[_vm._v("attachment")])],1),_vm._v(" "),_c('span',{staticClass:"attachment-button__text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }